const digest = 'a2f654f70d8457918ac13980111bb388091efd83c464f000a4617b2c36d2a6b0';
const css = `._toggleItem_1yfc0_1 button[role=switch]>span:first-of-type{border-color:#006fcf!important}._toggleItem_1yfc0_1 div[class*=toggleSwitch]{align-items:flex-start!important}._toggleItem_1yfc0_1 div[class*=toggleSwitch]>button[role=switch]{align-items:flex-start!important;padding:8px 0!important}._toggleItem_1yfc0_1 label[class*=label]{padding:12px 0!important}._toggleItem_1yfc0_1 div[class*=labelContainer]{flex:1 1 auto!important;min-width:0!important;width:100%!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'toggleItem': '_toggleItem_1yfc0_1' };
export const toggleItem = '_toggleItem_1yfc0_1';
export { css, digest };